
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSlider from './components/HeroSlider';
import ServicesSection from './components/ServicesSection';
import StaffSection from './components/StaffSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    // Set page title and meta description
    document.title = '岡山市不動産売買・買取専門｜おかやま不動産販売株式会社｜地域密着24年の実績';
    
    // Add structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "RealEstateAgent",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`,
          "name": "おかやま不動産販売株式会社",
          "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
          "logo": {
            "@type": "ImageObject",
            "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/logo.png`
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "○○町1-2-3",
            "addressLocality": "岡山市北区",
            "addressRegion": "岡山県",
            "postalCode": "700-0000",
            "addressCountry": "JP"
          },
          "telephone": "086-012-3456",
          "faxNumber": "086-012-3457",
          "foundingDate": "2000",
          "numberOfEmployees": "5",
          "openingHours": "Mo-Sa 09:00-18:00",
          "areaServed": {
            "@type": "City",
            "name": "岡山市"
          },
          "serviceType": ["不動産売買", "不動産買取", "不動産査定"],
          "priceRange": "$$",
          "sameAs": []
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "不動産の査定は無料ですか？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "はい、当社では不動産の査定を無料で行っております。専門スタッフが現地調査を行い、市場価格を反映した適正な査定額をご提示いたします。"
              }
            },
            {
              "@type": "Question", 
              "name": "売却にかかる期間はどのくらいですか？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "物件の条件や市場状況により異なりますが、一般的には3〜6ヶ月程度です。買取の場合は最短1週間での現金化も可能です。"
              }
            },
            {
              "@type": "Question",
              "name": "仲介手数料はいくらですか？",
              "acceptedAnswer": {
                "@type": "Answer", 
                "text": "仲介手数料は法定上限額（売買価格×3%+6万円+消費税）となります。詳細はお気軽にお問い合わせください。"
              }
            },
            {
              "@type": "Question",
              "name": "住宅ローンの相談もできますか？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "はい、住宅ローンのご相談も承っております。お客様の状況に応じて最適な金融機関をご紹介いたします。"
              }
            },
            {
              "@type": "Question",
              "name": "相続した不動産の売却も可能ですか？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "相続不動産の売却も承っております。必要な手続きや税務上の注意点についても丁寧にサポートいたします。"
              }
            },
            {
              "@type": "Question",
              "name": "遠方の物件でも対応していただけますか？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "岡山市を中心とした近隣地域であれば対応可能です。詳細はお問い合わせ時にご相談ください。"
              }
            }
          ]
        },
        {
          "@type": "WebSite",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`,
          "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
          "name": "おかやま不動産販売株式会社",
          "description": "岡山市北区を中心とした不動産売買・買取の専門会社",
          "publisher": {
            "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`
          }
        }
      ]
    };

    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      // Cleanup
      const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      <main>
        <HeroSlider />
        <ServicesSection />
        <StaffSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
